"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ActionTypes = require("./actionTypes");
function default_1(namespace) {
    const _ActionTypes = ActionTypes.default(namespace);
    function fetchRequest(fileUUID, hierarchyType = 'MINIMAL') {
        return {
            type: _ActionTypes.FETCH_REQUEST,
            payload: {
                uuid: fileUUID,
                hierarchyType
            }
        };
    }
    function fetchSuccess(revisions) {
        return {
            type: _ActionTypes.FETCH_SUCCESS,
            payload: revisions
        };
    }
    function fetchFailed(error) {
        return {
            type: _ActionTypes.FETCH_FAILED,
            payload: error
        };
    }
    function setColumnFilterString(key, value) {
        return {
            type: _ActionTypes.SET_COLUMN_FILTER_STRING,
            payload: {
                columnId: key,
                columnValue: value
            }
        };
    }
    function setOrder(order, orderBy) {
        return {
            type: _ActionTypes.SET_ORDER,
            payload: {
                order,
                orderBy
            }
        };
    }
    function toggleSelect(items, status) {
        return {
            type: _ActionTypes.TOGGLE_SELECT,
            payload: {
                items,
                status
            }
        };
    }
    function deleteLatestRevisionRequest(revisionUUID) {
        return {
            type: _ActionTypes.DELETE_LATEST_REVISION_REQUEST,
            payload: revisionUUID
        };
    }
    function deleteLatestRevisionSuccess() {
        return {
            type: _ActionTypes.DELETE_LATEST_REVISION_SUCCESS
        };
    }
    function deleteLatestRevisionFailed(error) {
        return {
            type: _ActionTypes.DELETE_LATEST_REVISION_FAILED,
            payload: error
        };
    }
    function clear() {
        return {
            type: _ActionTypes.CLEAR
        };
    }
    return {
        fetchRequest,
        fetchSuccess,
        fetchFailed,
        setColumnFilterString,
        setOrder,
        toggleSelect,
        deleteLatestRevisionRequest,
        deleteLatestRevisionSuccess,
        deleteLatestRevisionFailed,
        clear
    };
}
exports.default = default_1;
//# sourceMappingURL=actions.js.map